import { applyMiddleware, combineReducers, compose, createStore } from "redux";
import { persistReducer, persistStore } from "redux-persist";
import thunk from "redux-thunk";
import storage from "redux-persist/lib/storage";
import autoMergeLevel2 from "redux-persist/lib/stateReconciler/autoMergeLevel2";

// reducers
import trackerMap from "./reducers/trackerMap";
import aggregates from "./reducers/aggregates";
import session from "./reducers/session";
import campaigns from "./reducers/campaigns";
import offices from "./reducers/offices";
import sites from "./reducers/sites";
import siteCanvasses from "./reducers/siteCanvasses";
import siteRoutes from "./reducers/siteRoutes";
import canvassers from "./reducers/canvassers";
import users from "./reducers/users";
import scripts from "./reducers/scripts";
import reportCanvasserEvents from "./reducers/reportCanvasserEvents";
import crews from "./reducers/crews";
import permissions from "./reducers/permissions";
import alerts from "./reducers/alerts";
import infoFeed from "./reducers/infoFeed";
import doorCanvasses from "./reducers/doorCanvasses";
import doorCanvassPasses from "./reducers/doorCanvassPasses";
import doorCrews from "./reducers/doorCrews";
import responseAggregates from "./reducers/responseaggregates";
import turfCodes from "./reducers/turfCodes";
import assignedSites from "./reducers/assignedSites";
import assignedTurfs from "./reducers/assignedTurfs";
import dashboardParams from "./reducers/dashboardParams";
import siteNotes from "./reducers/siteNotes";
import alertConfigs from "./reducers/alertConfigs";
import surveys from "./reducers/surveys";

const rootReducer = combineReducers({
  trackerMap,
  aggregates,
  session,
  campaigns,
  offices,
  sites,
  siteRoutes,
  siteCanvasses,
  canvassers,
  users,
  scripts,
  reportCanvasserEvents,
  crews,
  permissions,
  alerts,
  infoFeed,
  doorCanvasses,
  doorCanvassPasses,
  doorCrews,
  responseAggregates,
  turfCodes,
  assignedSites,
  assignedTurfs,
  dashboardParams,
  siteNotes,
  alertConfigs,
  surveys,
});

const persistConfig = {
  key: "root",
  storage: storage, //new CookieStorage(Cookies/*, options */),
  stateReconciler: autoMergeLevel2, // see docs on merge process. This tracks changes several layers deep in the keys
  blacklist: [
    "reportCanvasserEvents",
    "alerts",
    "infoFeed",
    "assignedSites",
    "assignedTurfs",
    "permissions"
  ],
};

if (process.env.REACT_APP_DISABLE_PERSISTENCE === 'true') {
    persistConfig.blacklist.push('doorCrews')
}

const pReducer = persistReducer(persistConfig, rootReducer);

// export const store = createStore(pReducer, applyMiddleware(thunk));

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
export const store = createStore(
  pReducer,
  /* preloadedState, */ composeEnhancers(applyMiddleware(thunk))
);

export const persistor = persistStore(store);
